// ABOUTME: Provider for the AI Chat widget state
// ABOUTME: Allows opening/closing chat from sidebar; the hook lives in useChatContext.ts

import { useMemo, useState, type FC, type PropsWithChildren } from "react"
import { ChatContext, type ChatContextType } from "./useChatContext"

export const ChatProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const value = useMemo<ChatContextType>(
    () => ({
      isOpen,
      openChat: () => setIsOpen(true),
      closeChat: () => setIsOpen(false),
      toggleChat: () => setIsOpen((prev) => !prev),
    }),
    [isOpen],
  )

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>
}
